import React from "react";
import Lottie from "lottie-react";
import noMasterFormLottie from "../../data/notFoundListLottie.json";

export function NotFound() {
  return (
    <section className="no-list-sec mt-3">
      <div className="row">
        <div className="col-md-12 my-auto">
          <div className="no-list">
            <Lottie
              animationData={noMasterFormLottie}
              loop={true}
              autoplay={true}
              style={{ height: 174 }}
            />
            <h6>Sorry, no result found</h6>
            <p>We can't find any item matching your search</p>
          </div>
        </div>
      </div>
    </section>
  );
}
